import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Business from "./Business";
import Testimonial from "./Testimonial";

export default function Manufacturing() {

    

    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Manufacturing</h1>
                </div>
            </div>

           
            <Container className="it-overview mt-5 mb-5" >
                {/* <h6>OVERVIEW</h6> */}
                <h3 className="text-center" style={{ color: '#0e2b5c', paddingBottom: '15px' }}>Smart Factories for a Smarter Future</h3>
                <div className="overview-container" style={{ padding: '0 12%', color: '#627792', fontSize: '18px', fontWeight: '500', lineHeight: '1.8' }}>
                    <p >Manufacturing is entering the era of Industry 4.0, where automation, AI, and IoT redefine efficiency. Our solutions help businesses streamline production, reduce costs, and drive innovation. From supply chain automation to predictive maintenance, we ensure manufacturers can meet rising demands without compromising quality. Our digital transformation strategies help businesses embrace smart factories, improving productivity and sustainability.
                    </p>
                </div>
            </Container>

            

            {/**benefit */}

            <section className="py-5 text-light mb-5" style={{ backgroundColor: "#141b29" }}>
                {/* <h6 className="text-uppercase text-center text-info mb-2">Benefits to Manufacturing on</h6> */}
                <h2 className="text-center mb-5">Our Solutions for Manufacturing
                </h2>
                <Container>
                    <Row>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>IoT-Enabled Predictive Maintenance</h5>
                                <p>Prevent costly downtime by using real-time sensor data to detect wear and tear in machinery before failures occur. This proactive approach helps manufacturers reduce unexpected repairs and improve overall operational efficiency. By integrating IoT with machine learning, businesses can predict maintenance needs with greater accuracy, reducing disruptions and extending equipment lifespan.</p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>AI-Powered Supply Chain Optimization</h5>
                                <p>Leverage artificial intelligence to forecast demand, manage inventory, and enhance logistics, ensuring cost-effective operations. By automating procurement and distribution processes, manufacturers can eliminate waste and improve delivery timelines. AI-driven insights also help businesses navigate supply chain disruptions and adapt to market changes with greater agility.
                                </p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Smart factory automation boosts efficiency.</h5>
                                <p>Implement robotic process automation and AI-driven workflows to enhance production speed, precision, and quality. These intelligent systems allow manufacturers to reduce human error, improve workplace safety, and boost efficiency. Automated quality control systems further ensure product consistency, reducing defects and enhancing customer satisfaction.</p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Digital Twin Technology for Efficiency</h5>
                                <p>Utilize real-time digital replicas of physical assets to simulate production scenarios and optimize factory operations. This enables predictive decision-making, reducing risks and enhancing overall manufacturing agility. Digital twins also facilitate remote monitoring and troubleshooting, allowing businesses to minimize downtime and streamline maintenance operations.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>

            <Business />
        </>
    )
}